var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "svg",
    {
      staticClass: "icon",
      staticStyle: { fill: "#000000" },
      attrs: {
        xmlns: "http://www.w3.org/2000/svg",
        x: "0px",
        y: "0px",
        width: "20",
        height: "20",
        viewBox: "0 0 171 171"
      }
    },
    [
      _c(
        "g",
        {
          attrs: { transform: "translate(-25.79928,-25.79928) scale(1.3,1.3)" }
        },
        [
          _c(
            "g",
            {
              staticStyle: { "mix-blend-mode": "normal" },
              attrs: {
                fill: "none",
                "fill-rule": "nonzero",
                stroke: "none",
                "stroke-width": "1",
                "stroke-linecap": "butt",
                "stroke-linejoin": "miter",
                "stroke-miterlimit": "10",
                "stroke-dasharray": "",
                "stroke-dashoffset": "0",
                "font-family": "none",
                "font-weight": "none",
                "font-size": "none",
                "text-anchor": "none"
              }
            },
            [
              _c("path", {
                attrs: {
                  d: "M0,171.99519v-171.99519h171.99519v171.99519z",
                  fill: "none"
                }
              }),
              _vm._v(" "),
              _c("g", [
                _c("path", {
                  attrs: {
                    d:
                      "M124.6875,21.375h-78.375c-13.77262,0 -24.9375,11.16488 -24.9375,24.9375v78.375c0,13.77263 11.16488,24.9375 24.9375,24.9375h78.375c13.77263,0 24.9375,-11.16487 24.9375,-24.9375v-78.375c0,-13.77262 -11.16487,-24.9375 -24.9375,-24.9375z",
                    fill: "#000000"
                  }
                }),
                _vm._v(" "),
                _c("path", {
                  attrs: {
                    d:
                      "M85.5,42.75c-25.57875,0 -46.3125,17.54531 -46.3125,39.1875c0,14.51363 9.348,27.15338 23.20256,33.92569c-2.07337,4.45313 -5.08012,8.64263 -8.95256,12.38681c7.70212,-1.35375 14.93044,-4.18594 21.15056,-8.265c3.5055,0.71963 7.14637,1.14 10.91194,1.14c25.57875,0 46.3125,-17.54531 46.3125,-39.1875c0,-21.64219 -20.73375,-39.1875 -46.3125,-39.1875z",
                    fill: "#ffffff"
                  }
                })
              ]),
              _vm._v(" "),
              _c("path", { attrs: { d: "", fill: "none" } })
            ]
          )
        ]
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7018a4e1", { render: render, staticRenderFns: staticRenderFns })
  }
}